<template>
    <div class="form-elements col-md-12">
        <div class="row w-100" v-show="!download.load">
            <div class="col-md-12">
                <input v-model="data" type="date" class="form-control" placeholder="ex: 2022-01-30" :max='now'><br>
                <button class="btn btn-block btn-lg btn-secondary" @click="downloadFotosTeoricas">Gerar Planilha Fotos Teoricas</button>
                <button class="btn btn-block btn-lg btn-secondary" @click="downloadFotosPraticas">Gerar Planilha Fotos Praticas</button>
            </div>
        </div>
        <div v-show="download.load">
            <!-- <div class="d-flex justify-content-center">
                <span>Pode demorar um pouco...</span>
            </div> -->
            <div class="d-flex justify-content-center">
                <div class="btn-toolbar  d-inline-flex" role="toolbar" aria-label="Toolbar with button groups">
                    <component :animation-duration="1000" :is="'SpringSpinner'" :color="'#4AE387'" :size="80"></component>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import * as spinners from 'epic-spinners'
import RelatoriosController from '../RelatoriosController'

export default {
    name: 'FotosTeoricasPraticas',
    components: {
        ...spinners,
        RelatoriosController
    },

    data () {
        return {
            download: {
                load: false
            },
            data:   '',
            now:    '',
        }
    },
    methods: {
        downloadFotosTeoricas() {
            if(this.data === '')
            {
                this.launchToast('Selecione a o dia pretendido!');
            }else
            {
                this.download.load = true
                var data = {
                    day: this.data,
                }
                RelatoriosController.getQuantidadeFotosTeoricas(data, (response) => {
                    if(response.sucesso === false) {
                        this.download.load = false
                    } else {
                        var csv = 'data:text/csv;charset=utf-8,' + response.arquivo;
                        var dlnk = document.getElementById('downloadCSV');
                        dlnk.download="teoricas-quantidade-fotos.csv";
                        dlnk.href = csv;
                        dlnk.click();
                        this.download.load = false
                    }
                })
            }
        },
        downloadFotosPraticas() {
            if(this.data === '')
            {
                this.launchToast('Selecione a o dia pretendido!');
            }else
            {
                this.download.load = true
                var data = {
                    day: this.data,
                }
                RelatoriosController.getQuantidadeFotosPraticas(data, (response) => {
                    if(response.sucesso === false) {
                        this.download.load = false
                    } else {
                        var csv = 'data:text/csv;charset=utf-8,' + response.arquivo;
                        var dlnk = document.getElementById('downloadCSV');
                        dlnk.download="praticas-quantidade-fotos.csv";
                        dlnk.href = csv;
                        dlnk.click();
                        this.download.load = false
                    }
                })
            }
        },
        launchToast(msg)
        {
            this.$toasted.show(msg, {
                position: 'top-right',
                icon: 'fa-times'
            });
        },
        getDate(){
            let date = new Date()
            let day = String(date.getDate()).padStart(2, '0')
            let month = String(date.getMonth() + 1).padStart(2, '0')
            let year = date.getFullYear()
            this.now    =   year + '-' + month + '-' + day
        },
    },
    mounted() {
        this.getDate()
    },
}
</script>
